import { render, staticRenderFns } from "./dialog_buCode.vue?vue&type=template&id=410bd94e&scoped=true&"
import script from "./dialog_buCode.vue?vue&type=script&lang=js&"
export * from "./dialog_buCode.vue?vue&type=script&lang=js&"
import style0 from "./dialog_buCode.vue?vue&type=style&index=0&id=410bd94e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410bd94e",
  null
  
)

export default component.exports